import React, { useEffect, useState } from 'react';
import {
  ForgotPasswordForm,
  Translate,
  Spinner,
  ChangePassword,
} from 'components';
import { fulfilled, rejected, pending, clean } from 'redux-saga-thunk';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  transvoiceResourceAuthenticateUsingId,
  transvoiceLoginSuccess,
  transvoiceLoginRequest,
} from 'store/actions';
import decrypt from 'utils/cryptoUtil';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ResetPasswordContainer from './ResetPasswordContainer';

export function ForgotPasswordContainer({
  authenticateResourceUser = () => {},
  location = { search: '' },
  onCreateToken = () => {},
  onCleanToken = () => {},
  isFulfilled = false,
  isFailed = false,
  isAuthenticationFulfilled = false,
  isAuthenticationPending = false,
  cleanStoreProps = () => {},
  isPending = false,
}) {
  const navigate = useNavigate();
  const locationState = useLocation();
  const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);

  useEffect(() => {
    const isUserLoginFromEmailLink = locationState?.state?.data || null;
    if (isUserLoginFromEmailLink) {
      const encodedData = decodeURIComponent(isUserLoginFromEmailLink);
      const encryptedData = encodedData.replace(/\s/g, '+');

      if (encryptedData) {
        const plaintextData = decrypt(encryptedData);
        const paramsParser = new URLSearchParams(plaintextData);

        const interpreterId = paramsParser.get('interpreter_id');
        const resourceIdentifier = paramsParser.get('resource_identifier');
        const timeStamp = paramsParser.get('timestamp');

        if (interpreterId && resourceIdentifier && timeStamp) {
          onCreateToken(interpreterId, resourceIdentifier, timeStamp);
        }
      }
    }
  }, [locationState]);

  useEffect(() => {
    if (isFulfilled) {
      setShowResetPasswordForm(true);
    }
    if (isFailed) {
      navigate('/forgot-password');
      setShowResetPasswordForm(false);
    }
    cleanStoreProps('loginRequest');
  }, [isFulfilled, isFailed]);

  useEffect(() => {
    if (isAuthenticationFulfilled) {
      toast.success(Translate({ content: 'login.loginSuccessMessage' }));
      cleanStoreProps('resourceUserAuthenticateUsingId');
    }
  }, [isAuthenticationFulfilled]);

  const handlePassowrdResetSuccess = () => {
    navigate('/login');
    onCleanToken();
  };

  return (
    <>
      {(isPending || isAuthenticationPending) && <Spinner />}
      {!showResetPasswordForm ? (
        <ForgotPasswordForm onFormSubmit={authenticateResourceUser} />
      ) : (
        <ResetPasswordContainer
          onSuccess={handlePassowrdResetSuccess}
          render={({ onSetPassword, key }) => (
            <ChangePassword
              onSetPassword={onSetPassword}
              hideCurrentPassword
              className="tv-login-form__container "
              key={key}
            />
          )}
        />
      )}
    </>
  );
}

ForgotPasswordContainer.propTypes = {
  authenticateResourceUser: PropTypes.func,
  cleanStoreProps: PropTypes.func,
  onCreateToken: PropTypes.func,
  onCleanToken: PropTypes.func,
  location: PropTypes.shape({ search: PropTypes.string }),
  isFulfilled: PropTypes.bool,
  isPending: PropTypes.bool,
  isFailed: PropTypes.bool,
  isAuthenticationFulfilled: PropTypes.bool,
  isAuthenticationPending: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  authenticateResourceUser: data =>
    dispatch(transvoiceResourceAuthenticateUsingId(data)),
  cleanStoreProps: key => {
    dispatch(clean(key));
  },
  onCleanToken: () => {
    dispatch(transvoiceLoginSuccess({ AccessToken: null }, null, null));
  },
  onCreateToken: (interpreterId, resourceIdentifier, timeStamp) =>
    dispatch(
      transvoiceLoginRequest(interpreterId, resourceIdentifier, timeStamp),
    ),
});
const mapStateToProps = state => ({
  isFulfilled: fulfilled(state, 'loginRequest'),
  isPending: pending(state, 'loginRequest'),
  isAuthenticationFulfilled: fulfilled(
    state,
    'resourceUserAuthenticateUsingId',
  ),
  isAuthenticationPending: pending(state, 'resourceUserAuthenticateUsingId'),
  isFailed: rejected(state, 'loginRequest'),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordContainer);
